/* PILATIUM: un balayage horizontal du tableau n'ouvre pas de fiche. */
(function(){
  function init(root){
    if(!root||root.dataset.ptcmpPhotoReady==='true')return;
    root.dataset.ptcmpPhotoReady='true';
    var active=false,moved=false,x=0,y=0;
    root.addEventListener('pointerdown',function(e){
      var a=e.target.closest('[data-ptcmp-photo-link]');if(!a||!root.contains(a))return;
      active=true;moved=false;x=e.clientX;y=e.clientY;
    });
    root.addEventListener('pointermove',function(e){
      if(active&&(Math.abs(e.clientX-x)>8||Math.abs(e.clientY-y)>8))moved=true;
    });
    root.addEventListener('pointerup',function(){active=false;});
    root.addEventListener('pointercancel',function(){active=false;});
    root.addEventListener('click',function(e){
      var a=e.target.closest('[data-ptcmp-photo-link]');
      if(a&&root.contains(a)&&moved){e.preventDefault();e.stopPropagation();moved=false;}
    },true);
  }
  function boot(scope){(scope||document).querySelectorAll('.ptcmp').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true});else boot(document);
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();